import React from "react";
import { PageNewState, ProjectStakeholderListInitialState } from ".";

export const ProjectStakeholderListContext = React.createContext({
  pageState: ProjectStakeholderListInitialState,
  setPageState: (pageState: PageNewState) => {},
});
